import React from 'react';
import { Container, Typography, Box, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
export default function CrowdfundingLandingPageMobile() {
  // Link YouTube del video (da sostituire con il tuo)
  const videoUrl = "https://www.youtube.com/embed/KXVDOlXith8?si=6VZeBdNaKRNSnq36";
const navigate = useNavigate();
  return (
    <Container sx={{ bgcolor: 'white', py: 6 }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Unisciti alla nostra pre-campagna!
        </Typography>
        <Typography variant="h6" component="p">
          Scopri il progetto in anteprima e accedi a vantaggi esclusivi.
        </Typography>
      </Box>

      {/* Video */}
      <Box sx={{ position: 'relative', pb: '56.25%', mb: 6 }}>
        <iframe
          src={videoUrl}
          title="Video Pre-Campagna"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>

      {/* Call-to-Action */}
      <Stack direction="row" justifyContent="center" spacing={2}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate('/sitopubblico/crowdfundingprecampagna')}
        >
          Iscriviti alla pre-campagna
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          href="#info-progetto"
        >
          Scopri di più
        </Button>
      </Stack>

      {/* Sezione Info progetto */}
      <Box id="info-progetto" sx={{ mt: 8, maxWidth: 800, mx: 'auto', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Perché partecipare?
        </Typography>
        <Typography variant="body1" paragraph>
          La pre-campagna ti permette di essere tra i primi a conoscere il progetto,
          ricevere aggiornamenti esclusivi e accedere a vantaggi dedicati ai nostri sostenitori.
        </Typography>
        <Typography variant="body1" paragraph>
          Ogni contributo ci aiuta a crescere e a trasformare questa idea in realtà.
          Grazie per essere parte del nostro viaggio!
        </Typography>
      </Box>

      {/* Footer */}
      <Box sx={{ mt: 12, textAlign: 'center', color: 'gray' }}>
        <Typography variant="body2">
          © {new Date().getFullYear()} [Nome Progetto]. Tutti i diritti riservati.
        </Typography>
      </Box>
    </Container>
  );
}
